import React from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { IoClose } from 'react-icons/io5';
import FarmsioLogo from '../../../assets/img/illustrations/farmsio_logo.png';

export default function ModalComponent({
  showModal,
  handleCloseModal,
  description = {}, // Default value to prevent undefined error
  title
}) {
  return (
    <>
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        backdrop="static"
        keyboard={false}
        className="my-modal"
        size="lg"
      >
        <Modal.Body className="modal-body-watermark">
          <div className="modal-content-wrapper">
            <h4 className="mb-5 user-select-none">{title}</h4>
            <div>
              {Object.keys(description).map(
                key =>
                  description[key] !== '' && (
                    <Row className="mb-2" key={key}>
                      <Col className="fixed-width">
                        <h5
                          className="mb-1 font-poppins user-select-none"
                          style={{ fontSize: '1rem' }}
                        >
                          <span className="fw-normal text-green-600">
                            {key}
                          </span>
                        </h5>
                      </Col>
                      <Col className="full-width">
                        <p className="fs--1 fw-semi-bold mb-2 user-select-none">
                          <span
                            className="text-800 fw-normal desc"
                            style={{
                              fontSize: key === 'References' && '0.63rem'
                            }}
                          >
                            {description[key]}
                          </span>
                        </p>
                      </Col>
                    </Row>
                  )
              )}
            </div>
            <IoClose
              style={{
                position: 'absolute',
                top: 10,
                right: 15,
                cursor: 'pointer'
              }}
              onClick={handleCloseModal}
            />
          </div>
        </Modal.Body>
      </Modal>

      <style>{`
        .my-modal .modal-content {
          background: white;
          color: black;
          min-height: 200px;
        }
        .my-modal .modal-backdrop.show {
          backdrop-filter: blur(5px);
          background-color: rgba(0, 0, 0, 0.8);
        }
        .fixed-width {
          width: 150px;
          flex: 0 0 150px;
        }
        .full-width {
          flex: 1;
        }
        .desc {
          font-family: 'Poppins', sans-serif;
        }
        .modal-body-watermark {
          position: relative;
          padding: 20px;
        }
        .modal-body-watermark::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-image: url(${FarmsioLogo});
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
          opacity: 0.1; /* Adjust opacity as needed */
          pointer-events: none; /* Ensure the watermark does not interfere with content interaction */
          z-index: 1;
        }
        .modal-content-wrapper {
          position: relative;
          z-index: 2;
        }
      `}</style>
    </>
  );
}

ModalComponent.propTypes = {
  showModal: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.object
};
